<template>
  <div
    :class="[{ '--active': active }, 'workout-group p-relative mb-2 container']"
  >
    <template v-if="active">
      <h1 class="pl-2 pt-2 pb-1 m-0">
        {{ group.title }}
      </h1>
    </template>

    <group-header
      :large="showLarge"
      :group="group"
      :progress="progress"
      :with-title="!active"
      :can-capture="group.is_amrap"
      @captureClicked="
        startIndex =>
          $emit('captureClicked', {
            groupUid: group.uid,
            itemUid: null,
            startIndex
          })
      "
    />

    <list class="workout-group__list">
      <template v-for="item in group.items">
        <template v-if="item.is_rest">
          <div :key="item.id" class="workout-group__rest w-100 py-1 pl-2">
            <v-icon icon="history" size="1rem" />
            <span class="text-small font-weight-bold">
              {{ $t("components.workout.group.rest") }} {{ item.rest_period }}
              {{ humanInterval(item.rest_period, item.rest_interval) }}
            </span>
          </div>
        </template>

        <template v-else>
          <group-exercise-item
            :key="item.id"
            :item="item"
            :can-capture="!group.is_amrap"
            @click="() => showItem(item)"
            @captureClicked="
              startIndex =>
                $emit('captureClicked', {
                  groupUid: group.uid,
                  itemUid: item.uid,
                  startIndex
                })
            "
          />
        </template>
      </template>
    </list>

    <v-modal @close="() => (item = null)">
      <template :slot="`#exercise-${_uid}`">
        <span>
          <exercise-template
            v-if="exercise"
            :id="exercise.id"
            :title="exercise.title"
            :description="exercise.description"
            :banner="exercise.banner"
            :video="exercise.video"
            :field-uid="item.uid"
            hide-back
          />
        </span>
      </template>
    </v-modal>
  </div>
</template>

<script>
import { humanInterval } from "@/lib/time-utils"

import List from "@/components/List"
import GroupHeader from "@/components/workout/GroupHeader"
import GroupExerciseItem from "@/components/workout/GroupExerciseItem"

export default {
  components: {
    GroupHeader,
    GroupExerciseItem,
    List,
    ExerciseTemplate: () =>
      import("@/components/page-templates/ExerciseTemplate")
  },

  props: {
    group: { type: Object, required: true },
    active: { type: Boolean, default: false },
    progress: { type: Number, default: 0 },
    formId: { type: Number, default: null },
    workout: { type: Object, required: true }
  },

  data() {
    return {
      item: null,
      isLoading: false
    }
  },

  methods: {
    humanInterval,

    showItem(item) {
      this.item = item
      this.$router.push(`#exercise-${this._uid}`)
    }
  },

  computed: {
    exercise() {
      return this.item?.exercise
    },

    showLarge() {
      return (
        this.active &&
        (this.group.is_rest ||
          (this.group.items.length === 0 && this.group.has_timer))
      )
    },

    shouldShowHeader() {
      return (
        this.group.is_amrap ||
        this.group.rounds > 1 ||
        this.group.is_rest ||
        this.group.has_timer
      )
    }
  }
}
</script>

<style lang="scss">
@import "@/assets/styles/variables";

.workout-group__list {
  .v-list-item,
  .workout-group__rest {
    border-bottom: 1px solid #edf2f9;
    &:last-child {
      border-bottom: none;
    }
  }

  &.list {
    position: relative;
    background: transparent;
    z-index: 1;
  }
}

.workout-group__rest {
  margin-top: -1px;
  position: relative;
}
</style>
